export const brandLogosData = [
  {
    "id": "inextlabs-icon-coral",
    "name": "iNextLabs — Icon Mark (Coral)",
    "fileName": "iNextLabs - Icon Mark (Coral).png",
    "category": "Brand",
    "variant": "Coral Mark (Transparent BG)",
    "format": "PNG · High-Res 512px",
    "size": "18.4 KB",
    "src": "/images/brand/logos/iNextLabs - Icon Mark (Coral).png",
    "isDarkBg": false,
    "description": "Official standalone transparent icon mark (head & bulb) for favicons, mobile apps, and avatars."
  },
  {
    "id": "inextlabs-icon-white",
    "name": "iNextLabs — Icon Mark (White)",
    "fileName": "iNextLabs - Icon Mark (White).png",
    "category": "Brand",
    "variant": "White Mark (Transparent BG)",
    "format": "PNG · High-Res 512px",
    "size": "17.9 KB",
    "src": "/images/brand/logos/iNextLabs - Icon Mark (White).png",
    "isDarkBg": true,
    "description": "Official reversed standalone transparent icon mark for dark backgrounds and presentation decks."
  },
  {
    "id": "inextlabs-black",
    "name": "iNextLabs — Primary Logo (Dark)",
    "fileName": "iNextLabs - Black logo.png",
    "category": "Brand",
    "variant": "Dark Mark (For Light BG)",
    "format": "PNG · High-Res",
    "size": "13.2 KB",
    "src": "/images/brand/logos/iNextLabs - Black logo.png",
    "isDarkBg": false,
    "description": "Official master logo for white, light gray, and transparent backgrounds."
  },
  {
    "id": "inextlabs-white",
    "name": "iNextLabs — Primary Logo (White)",
    "fileName": "iNextLabs - White logo.png",
    "category": "Brand",
    "variant": "White Mark (For Dark BG)",
    "format": "PNG · High-Res",
    "size": "12.8 KB",
    "src": "/images/brand/logos/iNextLabs - White logo.png",
    "isDarkBg": true,
    "description": "Official reversed logo for dark navigation bars, footers, and solid dark backgrounds."
  },
  {
    "id": "docsai-black",
    "name": "DocsAI — Product Logo (Dark)",
    "fileName": "DocsAI - Black logo.png",
    "category": "DocsAI",
    "variant": "Dark Mark (For Light BG)",
    "format": "PNG · High-Res",
    "size": "9.8 KB",
    "src": "/images/brand/logos/DocsAI - Black logo.png",
    "isDarkBg": false,
    "description": "Official DocsAI intelligent document processing product mark."
  },
  {
    "id": "docsai-white",
    "name": "DocsAI — Product Logo (White)",
    "fileName": "DocsAI - White logo.png",
    "category": "DocsAI",
    "variant": "White Mark (For Dark BG)",
    "format": "PNG · High-Res",
    "size": "9.6 KB",
    "src": "/images/brand/logos/DocsAI - White logo.png",
    "isDarkBg": true,
    "description": "Official DocsAI product mark for dark backgrounds and presentation slides."
  },
  {
    "id": "engageai-black",
    "name": "EngageAI — Product Logo (Dark)",
    "fileName": "EngageAI - Black logo.png",
    "category": "EngageAI",
    "variant": "Dark Mark (For Light BG)",
    "format": "PNG · High-Res",
    "size": "13.2 KB",
    "src": "/images/brand/logos/EngageAI - Black logo.png",
    "isDarkBg": false,
    "description": "Official EngageAI customer intelligence & messaging product mark."
  },
  {
    "id": "engageai-white",
    "name": "EngageAI — Product Logo (White)",
    "fileName": "EngageAI - White logo.png",
    "category": "EngageAI",
    "variant": "White Mark (For Dark BG)",
    "format": "PNG · High-Res",
    "size": "12.8 KB",
    "src": "/images/brand/logos/EngageAI - White logo.png",
    "isDarkBg": true,
    "description": "Official EngageAI product mark for dark headers and media decks."
  },
  {
    "id": "insightsai-black",
    "name": "InsightsAI — Product Logo (Dark)",
    "fileName": "InsightsAI - Black logo.png",
    "category": "InsightsAI",
    "variant": "Dark Mark (For Light BG)",
    "format": "PNG · High-Res",
    "size": "10.5 KB",
    "src": "/images/brand/logos/InsightsAI - Black logo.png",
    "isDarkBg": false,
    "description": "Official InsightsAI predictive analytics & business forecasting product mark."
  },
  {
    "id": "insightsai-white",
    "name": "InsightsAI — Product Logo (White)",
    "fileName": "InsightsAI - White logo.png",
    "category": "InsightsAI",
    "variant": "White Mark (For Dark BG)",
    "format": "PNG · High-Res",
    "size": "9.7 KB",
    "src": "/images/brand/logos/InsightsAI - White logo.png",
    "isDarkBg": true,
    "description": "Official InsightsAI product mark for dark themes and event materials."
  }
];
